import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs';

import { ScootaversePageService } from 'app/modules/scootaverse/services/scootaverse-page.service';
import { Loggable } from 'app/utils/logging/loggable';
import EntryRule from 'entity/EntryRule';
import SocialEntryConfiguration from 'entity/SocialEntryConfiguration';
import SocialRoomSet from 'entity/SocialRoomSet';
import EntryFlowType from 'enums/EntryFlowType';
import EntryOptionType from 'enums/EntryOptionType';
@Component({
  selector: 'entry-flow-card',
  templateUrl: './entry-flow-card.component.html',
  styleUrls: ['./entry-flow-card.component.scss'],
  standalone: false,
})
export class EntryFlowCardComponent extends Loggable implements OnDestroy, OnInit {
  @Input() public flow?: SocialEntryConfiguration;
  @Input() public appliedRoomsName?: string[];
  @Input() public getRoomNames?: boolean;
  @Input() public isPreview?: boolean;
  @Input() public scootaverse?: SocialRoomSet;

  @Output() public triggerDelete = new EventEmitter<string>();

  public rulesPreview: EntryRule[] = [];
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor(private scootaversePageService: ScootaversePageService) {
    super();
    this.setDisplayName('EntryFlowCardComponent');
  }

  public ngOnInit(): void {
    if (!this.flow) {
      this.error('Entry flow card information not found.');
    }
    this.rulesPreview = this.getRulesForCard(this.flow?.rules);
  }

  public getAppliedRoomNames(): string[] {
    if (this.getRoomNames && this.flow) {
      const socialNameApplied: string[] = [];
      this.flow.associatedSocialIds?.forEach((socialId) => {
        this.scootaverse?.socials?.forEach((loadedSocial) => {
          if (loadedSocial.socialId === socialId) {
            if (loadedSocial.name) {
              socialNameApplied.push(loadedSocial.name);
            }
          }
        });
      });

      return socialNameApplied;
    } else if (this.appliedRoomsName) {
      return this.appliedRoomsName;
    } else {
      return [];
    }
  }

  public getRulesForCard(rules?: EntryRule[]): EntryRule[] {
    const visualRules: EntryRule[] = [];
    if (rules?.length) {
      rules.forEach((rule) => {
        if (rule.property || rule.value) {
          visualRules.push({
            property: rule.property,
            operator: rule.operator,
            value: rule.value,
          });
        }
        if (rule.subRules) {
          rule.subRules.forEach((subRule: EntryRule) => {
            visualRules.push({
              property: subRule.property,
              operator: subRule.operator,
              value: subRule.value,
            });
          });
        }
      });
    }
    return visualRules;
  }

  public getEntryFlowSpawnTypeText() {
    switch (this.flow?.entryOption) {
      case EntryOptionType.DEFAULT:
        return 'Default';
      case EntryOptionType.CUSTOM_RULES:
        return 'Group Former';
      default:
        return 'Custom Starting Point';
    }
  }

  public getPattern() {
    if (this.isFlowNotCustom) {
      switch (this.flow?.entryFlow) {
        case EntryFlowType.SPIRAL:
          return {
            title: 'Spiral Pattern',
            image: 'spiral-pattern',
          };
        case EntryFlowType.GRID:
          return {
            title: 'Grid Pattern',
            image: 'grid-pattern',
          };
        default:
          return {
            title: 'Spiral Pattern',
            image: 'spiral-pattern',
          };
      }
    } else {
      return {
        title: 'Start Point Preview',
        image: 'single-dot',
      };
    }
  }

  public get isFlowNotCustom() {
    return this.flow?.entryOption !== EntryOptionType.STARTING_POINT;
  }

  public getImagePath() {
    return `assets/images/group-patterns/${this.getPattern().image}.svg`;
  }

  public hasCoordinates() {
    return (
      this.flow?.entryOption === EntryOptionType.STARTING_POINT &&
      this.flow?.startingPointX !== undefined &&
      this.flow?.startingPointY !== undefined
    );
  }

  public onEditFlow() {
    void this.scootaversePageService.onEditEntryFlow(this.scootaverse?.socialRoomSetId, this.flow?.configurationId);
  }

  public onDeleteFlow() {
    this.triggerDelete?.emit(this.flow?.configurationId);
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
